import { render, staticRenderFns } from "./ClassAddressingInput.vue?vue&type=template&id=166a6b76&"
import script from "./ClassAddressingInput.vue?vue&type=script&lang=js&"
export * from "./ClassAddressingInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports